import { isFunction, noop } from "lodash";
import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { WorkflowsMomentumModal } from "@/react/components/WorkflowsMomentumModal";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { postApi } from "@circle-react/api";
import { ModalManager } from "@circle-react/components/Layout/ModalManagerProvider";
import { useToast } from "@circle-react/components/shared/uikit/ToastV2";
import { ToggleSwitchWithLabel } from "@circle-react/components/shared/uikit/ToggleSwitchWithLabel";
import { usePunditUserContext } from "@circle-react/contexts";
import { Dropdown } from "@circle-react-shared/uikit/Dropdown";

export const FeaturedAreaVisibilityAction = ({
  post,
  handleClose = noop,
  onChange,
  refetchPosts,
}) => {
  const hiddenFromFeaturedAreas = post.hide_from_featured_areas;
  const { success, error } = useToast();
  const { currentCommunityMember } = usePunditUserContext();

  const toggleVisibility = useMutation(
    () =>
      hiddenFromFeaturedAreas
        ? postApi.showInFeaturedAreas({ post })
        : postApi.hideFromFeaturedAreas({ post }),
    {
      onSuccess: async post => {
        onChange(post, { refetch: false });
        if (isFunction(refetchPosts)) {
          await refetchPosts();
        }
        success(
          I18n.t(
            hiddenFromFeaturedAreas
              ? "post.marked_unhidden"
              : "post.marked_hidden",
          ),
        );
        if (
          !hiddenFromFeaturedAreas &&
          isCommunityAdmin(currentCommunityMember)
        ) {
          void ModalManager.show(WorkflowsMomentumModal, {
            templateKey: "ai_curate_home_feed",
          });
        }
      },
      onError: () => {
        error(I18n.t("something_went_wrong"));
      },
    },
  );

  const handleClick = () => {
    handleClose();
    toggleVisibility.mutate();
  };

  return (
    <Dropdown.ItemLink onClick={handleClick}>
      <ToggleSwitchWithLabel
        label={t("post.hide_from_featured_areas")}
        field="hide_from_featured_areas"
        value={hiddenFromFeaturedAreas}
        variant="small"
      />
    </Dropdown.ItemLink>
  );
};
